import {addDoc, collection, deleteDoc, doc, getDoc, getDocs, query, setDoc, where} from "firebase/firestore";
import Promise from "bluebird";
import _ from "lodash";
import {fireStoreDB} from "../../firebase/client-app";

export {
    addThemes,
    updateSingleTheme,
    deleteSingleTheme,
    getSingleTheme,
    getSingleThemeById,
    searchThemes,
    prepareThemesList
}

const collectionName = 'themes';
const collectionReference = collection(fireStoreDB, collectionName);

const addThemes = (themes) => {
    return Promise.map(themes, async theme => {
        await addSingleTheme(theme);
    });
}

const addSingleTheme = (theme) => {
    return addDoc(collectionReference, theme);
}

const updateSingleTheme = (theme) => {
    const documentReference = doc(fireStoreDB, collectionName, theme.id);
    return setDoc(documentReference, theme);
}

const deleteSingleTheme = (theme) => {
    const documentReference = doc(fireStoreDB, collectionName, theme.id);
    return deleteDoc(documentReference);
}

const getSingleTheme = (themeId) => {
    const documentReference = doc(fireStoreDB, collectionName, themeId);
    return getDoc(documentReference);
}

const getSingleThemeById = async (themeId) => {
    const documentReference = doc(fireStoreDB, collectionName, themeId);
    const themeResult = await getDoc(documentReference);
    return prepareThemeData(themeResult);
}

const searchThemes = async (searchText) => {
    let searchQuery = query(collectionReference);

    if (searchText) {
        searchQuery = query(collectionReference, where("textList", "array-contains", searchText));
    }

    const themeResult = await getDocs(searchQuery);
    return prepareThemesList(themeResult);
}

const prepareThemesList = (themeResult) => {
    const themesList = [];

    _.forEach(themeResult.docs, themeDoc => {
        themesList.push({
            ...themeDoc.data(),
            id: themeDoc.id
        });
    });

    return themesList;
}

const prepareThemeData = (themeDoc) => {
    if (!themeDoc.exists) {
        return null;
    }

    return {
        ...themeDoc.data(),
        id: themeDoc.id
    }
}
